import React from 'react';
import * as S from './Metrics.styles';
import { GeneralMetrics } from './components/GeneralMetrics/GeneralMetrics';
import { Charts } from './components/Charts/Charts';
import { MetricsFilter } from './components/MetricsFilter/MetricsFilter';

export const Metrics = () => {
  return (
    <>
      <S.Container data-testid="metrics">
        <S.Content>
          <MetricsFilter />
          <GeneralMetrics />
          <Charts />
        </S.Content>
      </S.Container>
    </>
  );
};
